import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../";
import { ModalContent, SideBarContent } from "./types";

export const selectUi = (state: RootState) => state.ui;

export const selectUiIsDarkTheme = createSelector([selectUi], (ui) => ui.isDarkMode);

export const selectUiSidebar = createSelector([selectUi], (ui) => ui.sidebar);

export const selectUiModalVisible = (
  modal: ModalContent,
) => createSelector([selectUi], (ui) => ui.modal === modal);

export const selectUiAlert = createSelector([selectUi], (ui) => ui.alert);

export const selectUiSidebarChatOpen = createSelector([selectUiSidebar], (sidebar) => sidebar === SideBarContent.chat);

export const selectUiSidebarAppointmentOpen = createSelector([selectUiSidebar], (sidebar) => sidebar === SideBarContent.appointment);

export const selectUiPinnedSize = createSelector([selectUi], (ui) => ui.pinnedSizes);
